import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTASectionProps {
  text: string;
}
export const CTASection: React.FC<CTASectionProps> = ({
  text
}) => {
  return <div className="my-6 md:my-10 mt-8 mb-6 px-4 md:px-0" data-id="element-86">
      <a href="https://www.thaura.co/products/drift" className="block w-full max-w-[90%] mx-auto bg-[#84F75D] hover:bg-[#6dd84a] text-black font-bold py-4 px-8 rounded-lg text-xl flex items-center justify-center min-h-[44px]" data-id="element-87">
        {text} <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-88" />
      </a>
    </div>;
};